import * as types from '../constants/actionTypes';
import {showLoading, hideLoading} from './commonUseActions';
import {SEARCH_KEY} from "../constants/constants";
import stockOutServices from '../services/stockOutServices';
import orderServices from "../services/orderServices";
import contractorServices from "../services/contractorServices";
import styleServices from "../services/styleServices";

function getListItem (options = {}) {
  return (dispatch) => {
    showLoading(types, dispatch);

    stockOutServices.getListItem(options).then((res) => {
      hideLoading(types, dispatch);

      if (res) {
        dispatch({
          type: types.STOCK_OUT.GET_LIST_SUCCESS,
          data: res.data || []
        });
      }
    }, (error) => {
      hideLoading(types, dispatch);
    });
  };
}

function getDetail (id, options = {}) {
  return (dispatch) => {
    showLoading(types, dispatch);

    stockOutServices.getDetail(id, options).then((res) => {
      hideLoading(types, dispatch);

      if (res) {
        dispatch({
          type: types.STOCK_OUT.GET_DETAIL_SUCCESS,
          data: res.data || {}
        });
      }
    }, (error) => {
      hideLoading(types, dispatch);
    });
  };
}

function deleteItem (id) {
  return (dispatch) => {
    showLoading(types, dispatch);

    stockOutServices.deleteItem(id).then((res) => {
      hideLoading(types, dispatch);

      if (res) {
        dispatch({
          type: types.STOCK_OUT.RELOAD,
          data: true
        });
      }
    }, (error) => {
      hideLoading(types, dispatch, error);
    });
  };
}

function editItem (id, data) {
  return (dispatch) => {
    showLoading(types, dispatch);

    return stockOutServices.editItem(id, data).then((res) => {
      hideLoading(types, dispatch);
      if (res) {
        dispatch({
          type: types.STOCK_OUT.RELOAD,
          data: true
        });
      }
      return res
    }, (error) => {
      hideLoading(types, dispatch);
      return error
    });
  };
}

function addItem (data) {
  return (dispatch) => {
    showLoading(types, dispatch);

    return stockOutServices.addItem(data).then((res) => {
      hideLoading(types, dispatch);

      if (res) {
        dispatch({
          type: types.STOCK_OUT.RELOAD,
          data: true
        });
      }

      return res
    }, (error) => {
      hideLoading(types, dispatch);
      return error
    });
  };
}

function getMaterials (styleId, options) {
  return (dispatch) => {
    if(!styleId)
      return;

    showLoading(types, dispatch);
    stockOutServices.getMaterials(styleId, options).then((res) => {
      hideLoading(types, dispatch);

      if (res) {
        dispatch({
          type: types.STOCK_OUT.SET_MATERIALS,
          data: res.data
        });
      }
    }, (error) => {
      hideLoading(types, dispatch);
    });
  };
}

function searchInto(options, func,  name, field, bool = true) {
  return new Promise(resolve => {
    if(bool) {
      return resolve(options)
    } 
    func.then(rs => {
      const qr = {[name]: _.get(rs, 'data.items', []).reduce((ls, vl) => _.isArray(vl[field]) ? [...ls, ...vl[field]] : [...ls, vl[field]], [])}
      options.query = {...options.query, ...qr}
      return resolve(options)
    })
  })
}

function search ({search, options}) {
  return (dispatch) => {
    let func,  name, field, bool = true

    if(search.value != '') {
      switch(search.key) {
        case SEARCH_KEY.CUSTOMER_PO: {
          func = orderServices.getListOrder({projection: '_id', query: JSON.stringify({customerPO: {$regex: '.*' + search.value + '.*', $options: 'i'}})})
          name = 'orderId'
          field = '_id'
          bool = false
          break;
        }
        case SEARCH_KEY.STYLE: {
          func = styleServices.getAllStyles({projection: '_id', query: JSON.stringify({style: {$regex: '.*' + search.value + '.*', $options: 'i'}})})
          name = 'styleId'
          field = '_id'
          bool = false
          break;
        }
        case SEARCH_KEY.CONTRACTOR: {
          func = contractorServices.getListItem({projection: '_id', query: {name: {$regex: '.*' + search.value + '.*', $options: 'i'}}})
          name = 'contractorId'
          field = '_id'
          bool = false
          break;
        }
      }
    }

    let op = {}

    return searchInto(options, func,  name, field, bool).then(data => {
      op = data
      return getListItem(_.clone(op))(dispatch)
    }).then(res => {
      if(res && res.success && res.data && res.data.items && !res.data.items.length && op.pageNumber > 1) {
        _.set(op, "pageNumber", 1);
        getPurchases(op)(dispatch);
        op.pageNumber = 1;
      }
      return (_.set(res, "pageNumber", op.pageNumber))
    })
  };
}

export default {
  getListItem,
  deleteItem,
  editItem,
  addItem,
  getDetail,
  getMaterials,
  search
};
